import p2 from "react";
var Z = { exports: {} }, p = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c2;
function T2() {
  if (c2) return p;
  c2 = 1;
  var l = Symbol.for("react.transitional.element"), y = Symbol.for("react.fragment");
  function x(k, f, c) {
    var v = null;
    if (c !== void 0 && (v = "" + c), f.key !== void 0 && (v = "" + f.key), "key" in f) {
      c = {};
      for (var m in f)
        m !== "key" && (c[m] = f[m]);
    } else c = f;
    return f = c.ref, {
      $$typeof: l,
      type: k,
      key: v,
      ref: f !== void 0 ? f : null,
      props: c
    };
  }
  return p.Fragment = y, p.jsx = x, p.jsxs = x, p;
}
var T = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C2;
function y2() {
  return C2 || (C2 = 1, process.env.NODE_ENV !== "production" && function() {
    function l(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === x2 ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case M:
          return "Fragment";
        case m2:
          return "Portal";
        case X:
          return "Profiler";
        case J:
          return "StrictMode";
        case Y:
          return "Suspense";
        case $:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case I:
            return (e.displayName || "Context") + ".Provider";
          case F:
            return (e._context.displayName || "Context") + ".Consumer";
          case P:
            var r = e.render;
            return e = e.displayName, e || (e = r.displayName || r.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case W:
            return r = e.displayName || null, r !== null ? r : l(e.type) || "Memo";
          case B:
            r = e._payload, e = e._init;
            try {
              return l(e(r));
            } catch {
            }
        }
      return null;
    }
    function y(e) {
      return "" + e;
    }
    function x(e) {
      try {
        y(e);
        var r = !1;
      } catch {
        r = !0;
      }
      if (r) {
        r = console;
        var t = r.error, n = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t.call(
          r,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          n
        ), y(e);
      }
    }
    function k() {
    }
    function f() {
      if (j === 0) {
        D = console.log, e2 = console.info, r2 = console.warn, t2 = console.error, o2 = console.group, n2 = console.groupCollapsed, a2 = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: k,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      j++;
    }
    function c() {
      if (j--, j === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: b({}, e, { value: D }),
          info: b({}, e, { value: e2 }),
          warn: b({}, e, { value: r2 }),
          error: b({}, e, { value: t2 }),
          group: b({}, e, { value: o2 }),
          groupCollapsed: b({}, e, { value: n2 }),
          groupEnd: b({}, e, { value: a2 })
        });
      }
      0 > j && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function v(e) {
      if (V === void 0)
        try {
          throw Error();
        } catch (t) {
          var r = t.stack.trim().match(/\n( *(at )?)/);
          V = r && r[1] || "", l2 = -1 < t.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < t.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + V + e + l2;
    }
    function m(e, r) {
      if (!e || L) return "";
      var t = H.get(e);
      if (t !== void 0) return t;
      L = !0, t = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var n = null;
      n = g.H, g.H = null, f();
      try {
        var u = {
          DetermineComponentFrameRoot: function() {
            try {
              if (r) {
                var E = function() {
                  throw Error();
                };
                if (Object.defineProperty(E.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(E, []);
                  } catch (d) {
                    var R = d;
                  }
                  Reflect.construct(e, [], E);
                } else {
                  try {
                    E.call();
                  } catch (d) {
                    R = d;
                  }
                  e.call(E.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (d) {
                  R = d;
                }
                (E = e()) && typeof E.catch == "function" && E.catch(function() {
                });
              }
            } catch (d) {
              if (d && R && typeof d.stack == "string")
                return [d.stack, R.stack];
            }
            return [null, null];
          }
        };
        u.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var a = Object.getOwnPropertyDescriptor(
          u.DetermineComponentFrameRoot,
          "name"
        );
        a && a.configurable && Object.defineProperty(
          u.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var o = u.DetermineComponentFrameRoot(), C = o[0], w = o[1];
        if (C && w) {
          var s = C.split(`
`), h = w.split(`
`);
          for (o = a = 0; a < s.length && !s[a].includes(
            "DetermineComponentFrameRoot"
          ); )
            a++;
          for (; o < h.length && !h[o].includes(
            "DetermineComponentFrameRoot"
          ); )
            o++;
          if (a === s.length || o === h.length)
            for (a = s.length - 1, o = h.length - 1; 1 <= a && 0 <= o && s[a] !== h[o]; )
              o--;
          for (; 1 <= a && 0 <= o; a--, o--)
            if (s[a] !== h[o]) {
              if (a !== 1 || o !== 1)
                do
                  if (a--, o--, 0 > o || s[a] !== h[o]) {
                    var _ = `
` + s[a].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && _.includes("<anonymous>") && (_ = _.replace("<anonymous>", e.displayName)), typeof e == "function" && H.set(e, _), _;
                  }
                while (1 <= a && 0 <= o);
              break;
            }
        }
      } finally {
        L = !1, g.H = n, c(), Error.prepareStackTrace = t;
      }
      return s = (s = e ? e.displayName || e.name : "") ? v(s) : "", typeof e == "function" && H.set(e, s), s;
    }
    function O(e) {
      if (e == null) return "";
      if (typeof e == "function") {
        var r = e.prototype;
        return m(
          e,
          !(!r || !r.isReactComponent)
        );
      }
      if (typeof e == "string") return v(e);
      switch (e) {
        case Y:
          return v("Suspense");
        case $:
          return v("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case P:
            return e = m(e.render, !1), e;
          case W:
            return O(e.type);
          case B:
            r = e._payload, e = e._init;
            try {
              return O(e(r));
            } catch {
            }
        }
      return "";
    }
    function S() {
      var e = g.A;
      return e === null ? null : e.getOwner();
    }
    function d2(e) {
      if (K.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function v2(e, r) {
      function t() {
        u2 || (u2 = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          r
        ));
      }
      t.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: t,
        configurable: !0
      });
    }
    function E2() {
      var e = l(this.type);
      return s2[e] || (s2[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function g2(e, r, t, n, u, a) {
      return t = a.ref, e = {
        $$typeof: N,
        type: e,
        key: r,
        props: a,
        _owner: u
      }, (t !== void 0 ? t : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: E2
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function z(e, r, t, n, u, a) {
      if (typeof e == "string" || typeof e == "function" || e === M || e === X || e === J || e === Y || e === $ || e === w2 || typeof e == "object" && e !== null && (e.$$typeof === B || e.$$typeof === W || e.$$typeof === I || e.$$typeof === F || e.$$typeof === P || e.$$typeof === j2 || e.getModuleId !== void 0)) {
        var o = r.children;
        if (o !== void 0)
          if (n)
            if (U(o)) {
              for (n = 0; n < o.length; n++)
                q(o[n], e);
              Object.freeze && Object.freeze(o);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else q(o, e);
      } else
        o = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? n = "null" : U(e) ? n = "array" : e !== void 0 && e.$$typeof === N ? (n = "<" + (l(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : n = typeof e, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          n,
          o
        );
      if (K.call(r, "key")) {
        o = l(e);
        var C = Object.keys(r).filter(function(s) {
          return s !== "key";
        });
        n = 0 < C.length ? "{key: someKey, " + C.join(": ..., ") + ": ...}" : "{key: someKey}", i2[o + n] || (C = 0 < C.length ? "{" + C.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          n,
          o,
          C,
          o
        ), i2[o + n] = !0);
      }
      if (o = null, t !== void 0 && (x(t), o = "" + t), d2(r) && (x(r.key), o = "" + r.key), "key" in r) {
        t = {};
        for (var w in r)
          w !== "key" && (t[w] = r[w]);
      } else t = r;
      return o && v2(
        t,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), g2(e, o, a, u, S(), t);
    }
    function q(e, r) {
      if (typeof e == "object" && e && e.$$typeof !== _2) {
        if (U(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            A(n) && G(n, r);
          }
        else if (A(e))
          e._store && (e._store.validated = 1);
        else if (e === null || typeof e != "object" ? t = null : (t = Q && e[Q] || e["@@iterator"], t = typeof t == "function" ? t : null), typeof t == "function" && t !== e.entries && (t = t.call(e), t !== e))
          for (; !(e = t.next()).done; )
            A(e.value) && G(e.value, r);
      }
    }
    function A(e) {
      return typeof e == "object" && e !== null && e.$$typeof === N;
    }
    function G(e, r) {
      if (e._store && !e._store.validated && e.key == null && (e._store.validated = 1, r = b2(r), !f2[r])) {
        f2[r] = !0;
        var t = "";
        e && e._owner != null && e._owner !== S() && (t = null, typeof e._owner.tag == "number" ? t = l(e._owner.type) : typeof e._owner.name == "string" && (t = e._owner.name), t = " It was passed a child from " + t + ".");
        var n = g.getCurrentStack;
        g.getCurrentStack = function() {
          var u = O(e.type);
          return n && (u += n() || ""), u;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          r,
          t
        ), g.getCurrentStack = n;
      }
    }
    function b2(e) {
      var r = "", t = S();
      return t && (t = l(t.type)) && (r = `

Check the render method of \`` + t + "`."), r || (e = l(e)) && (r = `

Check the top-level render call using <` + e + ">."), r;
    }
    var h2 = p2, N = Symbol.for("react.transitional.element"), m2 = Symbol.for("react.portal"), M = Symbol.for("react.fragment"), J = Symbol.for("react.strict_mode"), X = Symbol.for("react.profiler"), F = Symbol.for("react.consumer"), I = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), Y = Symbol.for("react.suspense"), $ = Symbol.for("react.suspense_list"), W = Symbol.for("react.memo"), B = Symbol.for("react.lazy"), w2 = Symbol.for("react.offscreen"), Q = Symbol.iterator, x2 = Symbol.for("react.client.reference"), g = h2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = Object.prototype.hasOwnProperty, b = Object.assign, j2 = Symbol.for("react.client.reference"), U = Array.isArray, j = 0, D, e2, r2, t2, o2, n2, a2;
    k.__reactDisabledLog = !0;
    var V, l2, L = !1, H = new (typeof WeakMap == "function" ? WeakMap : Map)(), _2 = Symbol.for("react.client.reference"), u2, s2 = {}, i2 = {}, f2 = {};
    T.Fragment = M, T.jsx = function(e, r, t, n, u) {
      return z(e, r, t, !1, n, u);
    }, T.jsxs = function(e, r, t, n, u) {
      return z(e, r, t, !0, n, u);
    };
  }()), T;
}
process.env.NODE_ENV === "production" ? Z.exports = T2() : Z.exports = y2();
var i = Z.exports;
const R2 = (l) => /* @__PURE__ */ i.jsx(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l,
    children: /* @__PURE__ */ i.jsx(
      "path",
      {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z",
        fill: "currentColor"
      }
    )
  }
), O2 = (l) => /* @__PURE__ */ i.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l,
    children: [
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M27.9129 31.7704C27.1501 31.7704 26.5443 31.5698 26.0955 31.1685C25.6692 30.7673 25.456 30.2434 25.456 29.597C25.456 28.9282 25.6131 28.226 25.9272 27.4904C26.2413 26.7548 26.5442 26.0303 26.8359 25.3169C27.1501 24.5813 27.3071 23.9237 27.3071 23.3441C27.3071 22.6308 27.094 22.1069 26.6677 21.7725C26.2638 21.4158 25.8487 21.0926 25.4224 20.8028C24.9063 22.118 24.3678 23.3664 23.8069 24.5479C23.246 25.7293 22.786 26.621 22.427 27.2229L22.1241 26.6544C22.4382 26.0749 22.8421 25.2278 23.3357 24.1132C23.8518 22.9986 24.3566 21.7279 24.8502 20.3013C24.6259 20.0783 24.5137 19.8108 24.5137 19.4987C24.5137 18.83 24.7044 18.2838 25.0858 17.8603C25.4673 17.4367 25.7477 17.225 25.9272 17.225C26.174 17.225 26.3087 17.3364 26.3311 17.5594C26.376 17.76 26.3984 17.916 26.3984 18.0275C26.3984 18.1389 26.3311 18.3619 26.1965 18.6962C26.0843 19.0083 26.0282 19.1978 26.0282 19.2647C26.0282 19.5768 26.1965 19.8666 26.533 20.1341C26.892 20.3793 27.2959 20.6691 27.7446 21.0034C28.1934 21.3155 28.5861 21.7056 28.9226 22.1738C29.2816 22.6196 29.4611 23.1992 29.4611 23.9125C29.4611 24.5813 29.3153 25.2612 29.0236 25.9522C28.7543 26.6433 28.4739 27.3009 28.1822 27.9251C27.9129 28.5493 27.7783 29.0954 27.7783 29.5635C27.7783 29.9648 27.8793 30.2323 28.0812 30.366C28.2831 30.4998 28.5187 30.5667 28.788 30.5667C29.3265 30.5667 29.8762 30.3995 30.4371 30.0651C31.0205 29.7307 31.5814 29.3072 32.1199 28.7945C32.6584 28.2818 33.1408 27.7467 33.5671 27.1894C33.9935 26.6099 34.3076 26.0749 34.5095 25.5844L34.9471 25.9188C34.5207 26.8551 33.9374 27.7802 33.1969 28.6942C32.4565 29.5858 31.6263 30.3215 30.7064 30.901C29.8089 31.4806 28.8777 31.7704 27.9129 31.7704Z",
          fill: "#002B57"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M13.0488 33.493C11.4586 33.493 10.1707 33.0883 9.18522 32.2791C8.22212 31.4923 7.51659 30.4695 7.06863 29.2107C6.64308 27.9519 6.4303 26.6369 6.4303 25.2657C6.4303 23.4898 6.69907 21.7028 7.23662 19.9044C7.77416 18.1061 8.50209 16.3977 9.4204 14.7792C10.3611 13.1383 11.425 11.6884 12.6121 10.4296C13.7992 9.14826 15.0422 8.14795 16.3413 7.42863C17.6628 6.68682 18.9618 6.31592 20.2385 6.31592C21.1568 6.31592 21.8959 6.54071 22.4559 6.99029C23.0382 7.41739 23.3294 8.15919 23.3294 9.2157C23.3294 9.86759 23.2174 10.6094 22.9934 11.4411C22.7695 12.2504 22.4671 13.0371 22.0863 13.8014C21.7056 14.5432 21.28 15.1614 20.8097 15.6559C20.3617 16.1505 19.9025 16.3977 19.4322 16.3977C19.253 16.3977 19.0626 16.3415 18.8611 16.2291C18.6819 16.1167 18.5251 15.9144 18.3907 15.6222C18.7267 15.2401 19.0962 14.768 19.4994 14.206C19.9249 13.6216 20.3281 13.0146 20.7089 12.3852C21.0896 11.7333 21.392 11.1039 21.616 10.497C21.8624 9.86759 21.9855 9.31686 21.9855 8.8448C21.9855 8.39522 21.8512 8.03556 21.5824 7.76581C21.336 7.47358 20.9216 7.32747 20.3393 7.32747C19.3762 7.32747 18.3683 7.72085 17.3156 8.50761C16.2853 9.29438 15.2774 10.3509 14.2919 11.6771C13.3288 12.9809 12.4553 14.4421 11.6714 16.0605C10.8875 17.679 10.2603 19.3312 9.78996 21.0171C9.34201 22.7031 9.11803 24.3103 9.11803 25.8389C9.11803 26.9403 9.27481 27.9969 9.58838 29.0084C9.90195 29.9975 10.4059 30.7955 11.1002 31.4024C11.817 32.0318 12.7353 32.3465 13.8552 32.3465C15.0422 32.3465 16.2181 32.0093 17.3828 31.335C18.5699 30.6606 19.6562 29.7727 20.6417 28.6712C21.6272 27.5698 22.4111 26.3784 22.9934 25.0971L23.4638 25.4343C22.7247 26.8954 21.8288 28.2441 20.7761 29.4805C19.7234 30.6943 18.5475 31.6609 17.2484 32.3802C15.9493 33.122 14.5495 33.493 13.0488 33.493Z",
          fill: "#002B57"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M27.2916 14.8283C27.2916 15.4096 26.916 15.8809 26.3346 15.8809C25.7533 15.8809 25.282 15.4096 25.282 14.8283C25.282 14.2469 25.9446 13.78 26.526 13.78C27.1074 13.78 27.2916 14.2469 27.2916 14.8283Z",
          fill: "#002B57"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "38",
          height: "38",
          stroke: "#002B57",
          "stroke-width": "2"
        }
      )
    ]
  }
), S2 = (l) => /* @__PURE__ */ i.jsxs(
  "svg",
  {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l,
    children: [
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M37.9129 41.7703C37.1501 41.7703 36.5443 41.5697 36.0955 41.1684C35.6692 40.7672 35.456 40.2433 35.456 39.5968C35.456 38.9281 35.6131 38.2259 35.9272 37.4903C36.2413 36.7546 36.5442 36.0301 36.8359 35.3168C37.1501 34.5812 37.3071 33.9236 37.3071 33.344C37.3071 32.6306 37.094 32.1068 36.6677 31.7724C36.2638 31.4157 35.8487 31.0925 35.4224 30.8027C34.9063 32.1179 34.3678 33.3663 33.8069 34.5477C33.246 35.7292 32.786 36.6209 32.427 37.2228L32.1241 36.6543C32.4382 36.0747 32.8421 35.2276 33.3357 34.113C33.8518 32.9985 34.3566 31.7278 34.8502 30.3011C34.6259 30.0782 34.5137 29.8107 34.5137 29.4986C34.5137 28.8299 34.7044 28.2837 35.0858 27.8602C35.4673 27.4366 35.7477 27.2249 35.9272 27.2249C36.174 27.2249 36.3087 27.3363 36.3311 27.5592C36.376 27.7599 36.3984 27.9159 36.3984 28.0274C36.3984 28.1388 36.3311 28.3617 36.1965 28.6961C36.0843 29.0082 36.0282 29.1977 36.0282 29.2646C36.0282 29.5766 36.1965 29.8664 36.533 30.1339C36.892 30.3792 37.2959 30.6689 37.7446 31.0033C38.1934 31.3154 38.5861 31.7055 38.9226 32.1737C39.2816 32.6195 39.4611 33.1991 39.4611 33.9124C39.4611 34.5812 39.3153 35.2611 39.0236 35.9521C38.7543 36.6432 38.4739 37.3008 38.1822 37.925C37.9129 38.5491 37.7783 39.0953 37.7783 39.5634C37.7783 39.9647 37.8793 40.2322 38.0812 40.3659C38.2831 40.4997 38.5187 40.5665 38.788 40.5665C39.3265 40.5665 39.8762 40.3994 40.4371 40.065C41.0205 39.7306 41.5814 39.3071 42.1199 38.7943C42.6584 38.2816 43.1408 37.7466 43.5671 37.1893C43.9935 36.6097 44.3076 36.0747 44.5095 35.5843L44.9471 35.9187C44.5207 36.8549 43.9374 37.7801 43.1969 38.694C42.4565 39.5857 41.6263 40.3213 40.7064 40.9009C39.8089 41.4805 38.8777 41.7703 37.9129 41.7703Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M23.0488 43.493C21.4586 43.493 20.1707 43.0883 19.1852 42.2791C18.2221 41.4923 17.5166 40.4695 17.0686 39.2107C16.6431 37.9519 16.4303 36.6369 16.4303 35.2657C16.4303 33.4898 16.6991 31.7027 17.2366 29.9044C17.7742 28.1061 18.5021 26.3977 19.4204 24.7792C20.3611 23.1383 21.425 21.6884 22.6121 20.4296C23.7992 19.1483 25.0422 18.148 26.3413 17.4286C27.6628 16.6868 28.9618 16.3159 30.2385 16.3159C31.1568 16.3159 31.8959 16.5407 32.4559 16.9903C33.0382 17.4174 33.3294 18.1592 33.3294 19.2157C33.3294 19.8676 33.2174 20.6094 32.9934 21.4411C32.7695 22.2504 32.4671 23.0371 32.0863 23.8014C31.7056 24.5432 31.28 25.1614 30.8097 25.6559C30.3617 26.1505 29.9025 26.3977 29.4322 26.3977C29.253 26.3977 29.0626 26.3415 28.8611 26.2291C28.6819 26.1167 28.5251 25.9144 28.3907 25.6222C28.7267 25.2401 29.0962 24.768 29.4994 24.206C29.9249 23.6216 30.3281 23.0146 30.7089 22.3852C31.0896 21.7333 31.392 21.1039 31.616 20.497C31.8624 19.8676 31.9855 19.3169 31.9855 18.8448C31.9855 18.3952 31.8512 18.0356 31.5824 17.7658C31.336 17.4736 30.9216 17.3275 30.3393 17.3275C29.3762 17.3275 28.3683 17.7209 27.3156 18.5076C26.2853 19.2944 25.2774 20.3509 24.2919 21.6771C23.3288 22.9809 22.4553 24.4421 21.6714 26.0605C20.8875 27.679 20.2603 29.3312 19.79 31.0171C19.342 32.7031 19.118 34.3103 19.118 35.8389C19.118 36.9403 19.2748 37.9969 19.5884 39.0084C19.9019 39.9975 20.4059 40.7955 21.1002 41.4024C21.817 42.0318 22.7353 42.3465 23.8552 42.3465C25.0422 42.3465 26.2181 42.0093 27.3828 41.335C28.5699 40.6606 29.6562 39.7727 30.6417 38.6712C31.6272 37.5698 32.4111 36.3784 32.9934 35.0971L33.4638 35.4343C32.7247 36.8954 31.8288 38.2441 30.7761 39.4805C29.7234 40.6943 28.5475 41.6609 27.2484 42.3802C25.9493 43.122 24.5495 43.493 23.0488 43.493Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M37.2916 24.8283C37.2916 25.4096 36.916 25.8809 36.3346 25.8809C35.7533 25.8809 35.282 25.4096 35.282 24.8283C35.282 24.2469 35.9446 23.78 36.526 23.78C37.1074 23.78 37.2916 24.2469 37.2916 24.8283Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M48 12H12V48H48V12ZM10 10V50H50V10H10Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "38",
          height: "38",
          stroke: "#002B57",
          "stroke-width": "2"
        }
      )
    ]
  }
);
export {
  R2 as CloseIcon,
  O2 as Logo1Dark,
  S2 as Logo1White
};
